/* Roasthouse thema: gedrag. Winkelwagen via de Shopify Ajax-API, varianten, en de held met blendkiezer. */
(function () {
  'use strict';
  const RH = window.RH || {};
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];

  // waar de zakken in de foto's staan, als deel van de breedte en hoogte van de foto
  const ZAK_LOS = { x: .478, b: .375, boven: .004, onder: .836 };
  const PAKKET = [   // proefpakketfoto, van links naar rechts
    { handle: 'sabor-clasico', x: .155, b: .152, boven: .036, onder: .939 },
    { handle: 'pura-alegria', x: .308, b: .152, boven: .02, onder: .958 },
    { handle: 'simplissimo', x: .461, b: .152, boven: .005, onder: .975 },
    { handle: 'mattutina', x: .616, b: .152, boven: .005, onder: .975 },
    { handle: 'grano-suave', x: .771, b: .152, boven: .02, onder: .958 },
    { handle: 'grano-fuerte', x: .924, b: .152, boven: .036, onder: .937 }
  ];

  /* ---------- geld ---------- */
  function geld(centen) {
    const fmt = RH.geld || '€{{amount_with_comma_separator}}';
    const n = (centen || 0) / 100;
    const met = (dec, duizend, komma) => {
      const [h, d] = n.toFixed(dec).split('.');
      return h.replace(/\B(?=(\d{3})+(?!\d))/g, duizend) + (dec ? komma + d : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, soort) => ({
      amount: met(2, ',', '.'),
      amount_no_decimals: met(0, ',', '.'),
      amount_with_comma_separator: met(2, '.', ','),
      amount_no_decimals_with_comma_separator: met(0, '.', ',')
    })[soort] || met(2, '.', ','));
  }

  /* ---------- dialogen zonder dat de pagina verspringt ---------- */
  function open(dlg) { if (dlg && !dlg.open) { document.documentElement.classList.add('rh-vast'); dlg.showModal(); } }
  function sluit(dlg) { if (dlg && dlg.open) dlg.close(); }
  $$('dialog').forEach(d => d.addEventListener('close', () => {
    if (!$('dialog[open]')) document.documentElement.classList.remove('rh-vast');
  }));

  /* ---------- melding ---------- */
  function meld(tekst) {
    const m = $('[data-melding]'); if (!m) return;
    m.textContent = tekst; m.classList.add('zichtbaar');
    clearTimeout(meld.t); meld.t = setTimeout(() => m.classList.remove('zichtbaar'), 2800);
  }

  /* ---------- winkelwagen ---------- */
  const mand = $('#mand');
  let laatstVerwijderd = null;

  async function api(url, body) {
    const r = await fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    });
    const data = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(data.description || data.message || 'Dat lukte niet, probeer het opnieuw.');
    return data;
  }
  const haalMand = () => api(RH.routes.cart + '.js');

  function tekenMand(c) {
    $$('[data-mand-aantal]').forEach(el => { el.textContent = c.item_count; el.toggleAttribute('data-leeg', c.item_count === 0); });
    const lijst = $('[data-mand-lijst]'); if (!lijst) return;
    const tpl = $('#mand-regel');
    lijst.innerHTML = '';
    c.items.forEach((item, i) => {
      const el = tpl.content.firstElementChild.cloneNode(true);
      const eigen = (RH.fotos || {})[item.handle];
      if (eigen) el.style.setProperty('--blend', eigen.kleur);
      el.querySelector('[data-r="link"]').href = item.url;
      const img = el.querySelector('[data-r="foto"]');
      img.src = eigen ? eigen.foto : (item.image || ''); img.alt = item.product_title;
      el.querySelector('[data-r="naam"]').textContent = item.product_title;
      const det = [];
      if (item.variant_title && !item.product_has_only_default_variant) det.push(item.variant_title.replace(/ \/ /g, ' · '));
      if (item.selling_plan_allocation) det.push('abonnement ' + planNaam(item.selling_plan_allocation.selling_plan.name).toLowerCase());
      el.querySelector('[data-r="detail"]').textContent = det.join(' · ');
      el.querySelector('[data-r="aantal"]').textContent = item.quantity;
      el.querySelector('[data-r="prijs"]').textContent = geld(item.final_line_price);
      el.querySelector('[data-r="min"]').onclick = () => wijzig(i + 1, item.quantity - 1, item);
      el.querySelector('[data-r="plus"]').onclick = () => wijzig(i + 1, item.quantity + 1, item);
      el.querySelector('[data-r="weg"]').onclick = () => wijzig(i + 1, 0, item);
      lijst.appendChild(el);
    });
    const leeg = $('[data-mand-leeg]'); if (leeg) leeg.hidden = c.item_count > 0;
    const voet = $('[data-mand-voet]'); if (voet) voet.hidden = c.item_count === 0;
    const tot = $('[data-mand-totaal]'); if (tot) tot.textContent = geld(c.total_price);
    const g = mand && $('[data-gratis]', mand);
    if (g) {   // hoeveel nog tot gratis verzending
      const grens = Number(g.dataset.grens) || 0, rest = grens - c.total_price;
      const tekst = $('[data-gratis-tekst]', g), b = document.createElement('b');
      g.classList.toggle('gehaald', rest <= 0);
      if (rest > 0) { b.textContent = geld(rest); tekst.replaceChildren('Nog ', b, ' tot gratis verzending'); }
      else { b.textContent = 'Gratis verzending'; tekst.replaceChildren(b, ' voor deze bestelling'); }
      $('[data-gratis-balk]', g).style.setProperty('--vol', Math.min(100, grens ? c.total_price / grens * 100 : 100) + '%');
    }
    const h = $('[data-mand-herstel]'); if (h) h.hidden = !laatstVerwijderd;
  }

  async function wijzig(regel, aantal, item) {
    try {
      if (aantal === 0) {
        laatstVerwijderd = { id: item.variant_id, quantity: item.quantity, selling_plan: item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.id : undefined, properties: item.properties || {} };
        const n = $('[data-mand-herstel-naam]'); if (n) n.textContent = item.product_title;
      }
      tekenMand(await api(RH.routes.change + '.js', { line: regel, quantity: aantal }));
    } catch (e) { meld(e.message); }
  }

  async function voegToe(items) {
    await api(RH.routes.add + '.js', { items });
    laatstVerwijderd = null;
    tekenMand(await haalMand());
    open(mand);
  }

  document.addEventListener('click', async e => {
    const om = e.target.closest('[data-open-mand]');
    if (om && mand) { e.preventDefault(); tekenMand(await haalMand()); open(mand); return; }
    const od = e.target.closest('[data-open-dialoog]');
    if (od) { e.preventDefault(); open(document.getElementById(od.dataset.openDialoog)); return; }
    const ml = e.target.closest('[data-menulink]');
    if (ml) { sluit(ml.closest('dialog')); return; }
    const s = e.target.closest('[data-sluit]');
    if (s) { e.preventDefault(); sluit(s.closest('dialog')); return; }
    if (e.target.closest('[data-mand-herstel-knop]') && laatstVerwijderd) {
      const r = laatstVerwijderd; laatstVerwijderd = null;
      try { await api(RH.routes.add + '.js', { items: [r] }); tekenMand(await haalMand()); } catch (err) { meld(err.message); }
      return;
    }
    const kies = e.target.closest('[data-kies]');
    if (kies) { e.preventDefault(); openKeuze(kies.dataset.kies); return; }
    if (e.target.tagName === 'DIALOG') sluit(e.target);
  });

  /* ---------- keuzepaneel: eerst gewicht, maling en levering kiezen ---------- */
  const keuze = $('#kiezen');
  const productCache = {};
  const planNaam = n => n.replace('Maandelijkse levering', 'Elke maand').replace('Tweewekelijkse levering', 'Elke 2 weken');
  let kp = null;   // het product dat nu in het paneel staat

  // standaardkeuze overal: 500 gram en bonen, anders de eerste die wel leverbaar is
  function voorkeursVariant(varianten) {
    const leverbaar = varianten.filter(v => v.available !== false && v.beschikbaar !== false);
    const heeft = (v, w) => (v.options || v.opties || []).includes(w);
    return leverbaar.find(v => heeft(v, '500 gram') && heeft(v, 'Bonen')) || leverbaar.find(v => heeft(v, 'Bonen')) || leverbaar.find(v => heeft(v, '500 gram')) || leverbaar[0] || varianten[0];
  }
  const bonenEerst = waarden => [...waarden].sort((a, b) => (b === 'Bonen') - (a === 'Bonen'));

  async function openKeuze(handle) {
    if (!keuze) return;
    const k = s => keuze.querySelector('[data-k="' + s + '"]');
    try {
      kp = productCache[handle] || (productCache[handle] = await api(RH.routes.root.replace(/\/$/, '') + '/products/' + handle + '.js'));
    } catch (err) { meld('Dit product kon niet geladen worden.'); return; }
    const eigen = (RH.fotos || {})[kp.handle];
    keuze.style.setProperty('--blend', eigen ? eigen.kleur : '#8a6a50');
    k('foto').src = eigen ? eigen.foto : (kp.featured_image || ''); k('foto').alt = kp.title;
    k('naam').textContent = kp.title;
    k('aantal').value = 1;
    k('fout').hidden = true;
    const eerste = voorkeursVariant(kp.variants);
    let html = '';
    const namen = kp.options.map(o => (typeof o === 'string' ? o : o.name));
    const heeftOpties = !(kp.variants.length === 1 && kp.variants[0].title === 'Default Title');
    if (heeftOpties) namen.forEach((naam, i) => {
      let waarden = [...new Set(kp.variants.map(v => v.options[i]))];
      if (naam === 'Maling') waarden = bonenEerst(waarden);   // bonen links
      html += `<fieldset class="groep"><legend class="label">${naam}</legend><div class="tegels${waarden.length === 2 ? ' twee' : ''}">` +
        waarden.map(w => `<label class="tegel"><input type="radio" name="k-optie-${i}" value="${w.replace(/"/g, '&quot;')}" data-k-optie="${i}"${eerste.options[i] === w ? ' checked' : ''}><span>${w}</span></label>`).join('') + '</div></fieldset>';
    });
    const plannen = (kp.selling_plan_groups || []).flatMap(g => g.selling_plans);
    if (plannen.length) {
      html += '<fieldset class="groep"><legend class="label">Eenmalig of abonnement</legend><div class="tegels">' +
        (kp.requires_selling_plan ? '' : '<label class="tegel"><input type="radio" name="k-plan" value="" checked><span>Eenmalig</span></label>') +
        plannen.map((p, i) => `<label class="tegel"><input type="radio" name="k-plan" value="${p.id}"${kp.requires_selling_plan && i === 0 ? ' checked' : ''}><span>${planNaam(p.name)}<small>abonnement</small></span></label>`).join('') +
        '</div></fieldset>';
    }
    k('opties').innerHTML = html;
    werkKeuzeBij();
    sluit(mand);
    open(keuze);
  }

  function keuzeVariant() {
    const keuzes = $$('[data-k-optie]:checked', keuze).sort((a, b) => a.dataset.kOptie - b.dataset.kOptie).map(i => i.value);
    if (!keuzes.length) return kp.variants[0];
    return kp.variants.find(v => v.options.every((o, i) => o === keuzes[i]));
  }

  function werkKeuzeBij() {
    const k = s => keuze.querySelector('[data-k="' + s + '"]');
    const v = keuzeVariant();
    const plan = ($('[name="k-plan"]:checked', keuze) || {}).value;
    const n = Math.max(1, Number(k('aantal').value) || 1);
    const knop = k('toevoegen');
    if (!v) { knop.disabled = true; k('knoptekst').textContent = 'Niet beschikbaar'; return; }
    let prijs = v.price;
    const a = plan && (v.selling_plan_allocations || []).find(x => String(x.selling_plan_id) === String(plan));
    if (a) prijs = a.price;
    k('prijs').textContent = geld(prijs * n);
    knop.disabled = !v.available;
    k('knoptekst').textContent = !v.available ? 'Uitverkocht' : plan ? 'Start abonnement' : 'In winkelwagen';
  }

  if (keuze) {
    keuze.addEventListener('change', werkKeuzeBij);
    keuze.querySelector('[data-k="aantal"]').addEventListener('input', werkKeuzeBij);
    keuze.addEventListener('click', async e => {
      const st = e.target.closest('[data-k-stap]');
      const veld = keuze.querySelector('[data-k="aantal"]');
      if (st) { veld.value = Math.max(1, Math.min(20, (Number(veld.value) || 1) + Number(st.dataset.kStap))); werkKeuzeBij(); return; }
      const knop = e.target.closest('[data-k="toevoegen"]');
      if (!knop) return;
      const v = keuzeVariant(); if (!v) return;
      const plan = ($('[name="k-plan"]:checked', keuze) || {}).value;
      const item = { id: v.id, quantity: Math.max(1, Number(veld.value) || 1) };
      if (plan) item.selling_plan = Number(plan);
      knop.disabled = true;
      try { sluit(keuze); await voegToe([item]); }
      catch (err) { open(keuze); const f = keuze.querySelector('[data-k="fout"]'); f.textContent = err.message; f.hidden = false; }
      finally { werkKeuzeBij(); }
    });
  }

  /* ---------- kop wordt donker zodra je scrolt ---------- */
  const kop = $('[data-kop]');
  if (kop) { const bij = () => kop.classList.toggle('dicht', scrollY > 24); addEventListener('scroll', bij, { passive: true }); bij(); }

  /* ---------- productpagina ---------- */
  const pp = $('[data-product]');
  if (pp) {
    const product = JSON.parse($('[data-product-json]', pp).textContent);
    const form = $('[data-productformulier]', pp);
    const idVeld = $('[data-variant-id]', pp);
    const prijs = $('[data-prijs]', pp);
    const knop = $('[data-toevoegen]', pp);
    const knopTekst = $('[data-knoptekst]', pp);
    const aantal = $('[data-aantal]', pp);
    function huidige() {
      const keuze = $$('[data-optie]:checked', pp).sort((a, b) => a.dataset.optie - b.dataset.optie).map(i => i.value);
      if (!keuze.length) return product.variants[0];
      return product.variants.find(v => v.options.every((o, i) => o === keuze[i]));
    }
    function bij() {
      const v = huidige();
      const plan = ($('[name="selling_plan"]:checked', pp) || {}).value;
      const n = Math.max(1, Number(aantal.value) || 1);
      if (!v) { knop.disabled = true; knopTekst.textContent = 'Niet beschikbaar'; return; }
      idVeld.value = v.id;
      let p = v.price;
      if (plan && v.selling_plan_allocations) {
        const a = v.selling_plan_allocations.find(x => String(x.selling_plan_id) === String(plan));
        if (a) p = a.price;
      }
      prijs.textContent = geld(p * n);
      knop.disabled = !v.available;
      knopTekst.textContent = !v.available ? 'Uitverkocht' : plan ? 'Start abonnement' : 'In winkelwagen';
      const url = new URL(location.href); url.searchParams.set('variant', v.id);
      history.replaceState(null, '', url);
    }
    pp.addEventListener('change', bij);
    pp.addEventListener('click', e => {
      const st = e.target.closest('[data-aantal-stap]'); if (!st) return;
      aantal.value = Math.max(1, Math.min(20, (Number(aantal.value) || 1) + Number(st.dataset.aantalStap)));
      bij();
    });
    aantal.addEventListener('input', bij);
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const plan = ($('[name="selling_plan"]:checked', pp) || {}).value;
      const item = { id: Number(idVeld.value), quantity: Math.max(1, Number(aantal.value) || 1) };
      if (plan) item.selling_plan = Number(plan);
      knop.disabled = true;
      try { await voegToe([item]); } catch (err) { meld(err.message); } finally { bij(); }
    });
    bij();
  }

  /* ---------- abonnement samenstellen (collectie 'abonnement') ---------- */
  // koffie, hoeveelheid, maling en ritme kiezen; rechts (op de telefoon onderaan) loopt het overzicht mee
  const KOPJES_PER_250 = 30;   // vaste afspraak: 250 gram = 30 kopjes, 500 gram = 60, 1 kilo = 120
  const GRAM_PER_KOP = 250 / KOPJES_PER_250;
  const DAGEN = { maand: 365 / 12, twee: 14 };
  function abonneer(el) {
    const raster = $('[data-abo-raster]', el);
    let lijst;
    try { lijst = JSON.parse($('[data-abo-json]', el).textContent); } catch (e) { return; }
    lijst = lijst.filter(p => p.varianten && p.varianten.length && p.plannen && p.plannen.length);
    if (!raster || !lijst.length) return;
    const isPakket = p => !p.opties.includes('Gewicht');
    lijst.sort((a, b) => isPakket(a) - isPakket(b));   // proefpakket als brede tegel onderaan
    const blends = lijst.filter(p => !isPakket(p));
    const optieWaarden = naam => [...new Set(lijst.flatMap(p => p.opties.includes(naam) ? p.varianten.map(v => v.opties[p.opties.indexOf(naam)]) : []))];
    const GEWICHTEN = optieWaarden('Gewicht');
    const MALINGEN = optieWaarden('Maling').sort((a, b) => /bonen/i.test(b) - /bonen/i.test(a));   // bonen eerst en standaard
    const gram = g => g === 'pakket' ? 1500 : /kilo/i.test(g) ? parseFloat(g) * 1000 : parseInt(g, 10) || 0;
    const kopjes = g => Math.round(g / GRAM_PER_KOP);
    const soortPlan = naam => /week|weken|wekelijk/i.test(naam) ? 'twee' : 'maand';
    const ritmeTekst = r => r === 'twee' ? 'Elke 2 weken' : 'Elke maand';
    const RITMES = [...new Set(lijst[0].plannen.map(pl => soortPlan(pl.naam)))].sort((a, b) => (a === 'maand') - (b === 'maand')).reverse();
    const st = { p: null, gewicht: GEWICHTEN.includes('500 gram') ? '500 gram' : GEWICHTEN[0], maling: MALINGEN[0], ritme: RITMES[0], aantal: 1, kopjes: 2 };   // standaard 500 gram en bonen

    const svg = (inhoud, extra = '') => `<svg class="rh-ico abo-ico" viewBox="0 0 24 24" aria-hidden="true"${extra}>${inhoud}</svg>`;
    const ico = {
      vink: '<svg class="rh-ico" aria-hidden="true"><use href="#i-vink"/></svg>',
      min: '<svg class="rh-ico" aria-hidden="true"><use href="#i-min"/></svg>',
      plus: '<svg class="rh-ico" aria-hidden="true"><use href="#i-plus"/></svg>',
      pijl: '<svg class="rh-ico" aria-hidden="true"><use href="#i-pijl"/></svg>',
      zak: h => `<svg class="abo-zakje" viewBox="0 0 20 28" style="height:${h}px" aria-hidden="true"><path d="M5 1.5h10l1.6 4.5H3.4z"/><path d="M3.4 6h13.2l-.9 20.5H4.3z"/><path d="M7 13h6"/></svg>`,
      bonen: svg('<g transform="rotate(32 12 12)"><ellipse cx="12" cy="12" rx="6" ry="9"/><path d="M12 3.2c-2.2 3-2.2 5.8 0 8.8s2.2 5.8 0 8.8"/></g>'),
      gemalen: svg('<path d="M3 20c1.6-5.4 4.8-8.2 9-8.2s7.4 2.8 9 8.2z"/><path d="M9 8.5h.01M12.5 6h.01M15 9h.01M11 3.5h.01"/>'),
      kop: svg('<path d="M4 9.5h12.5v4.2a5.8 5.8 0 0 1-5.8 5.8h-.9A5.8 5.8 0 0 1 4 13.7z"/><path d="M16.5 11h1.3a2.6 2.6 0 0 1 0 5.2h-1.6"/><path d="M8 3.5c0 1.6 1.2 1.6 1.2 3.2M11.8 3.5c0 1.6 1.2 1.6 1.2 3.2"/>'),
      kalender: n => svg(`<rect x="3.5" y="5" width="17" height="15.5" rx="1.5"/><path d="M3.5 9.5h17M8 3v4M16 3v4"/><text x="12" y="17.6" text-anchor="middle" font-size="7" font-weight="700" fill="currentColor" stroke="none">${n}</text>`)
    };
    const meter = k => `<span class="meter" role="img" aria-label="Intensiteit ${k} van 5">${[1, 2, 3, 4, 5].map(i => `<i class="${i <= k ? 'aan' : ''}"></i>`).join('')}</span>`;
    const laagste = p => { const leverbaar = p.varianten.filter(v => v.beschikbaar); return Math.min(...(leverbaar.length ? leverbaar : p.varianten).map(v => v.prijs)); };
    const zoek = (p, gewicht, maling) => p.varianten.find(v => p.opties.every((o, i) => o === 'Gewicht' ? v.opties[i] === gewicht : o === 'Maling' ? v.opties[i] === maling : true));
    const kopjesTekst = x => {
      const r = Math.round(x * 2) / 2;
      if (r < .5) return 'minder dan een half kopje';
      if (r === .5) return 'een half kopje';
      if (r === 1) return 'één kopje';
      return String(r).replace('.', ',') + ' kopjes';
    };

    const tegel = p => {
      const pk = isPakket(p);
      const voet = pk
        ? `<span class="abo-stippen">${blends.map(b => `<i style="background:${b.kleur}"></i>`).join('')}</span>`
        : meter(p.kracht);
      return `<label class="abo-koffie${pk ? ' breed' : ''}" style="--kleur:${p.kleur || '#8a6a50'}">
        <input class="rh-verborgen" type="radio" name="abo-koffie" value="${p.handle}">
        <span class="abo-koffie-beeld"><i class="abo-gloed"></i><img src="${p.foto}" alt="" loading="lazy" decoding="async"></span>
        <span class="abo-koffie-tekst">
          <span class="abo-koffie-naam smal">${pk ? 'Proefpakket' : p.naam}</span>
          <span class="abo-koffie-kort">${pk ? 'Elke levering alle zes blends, elk 250 gram. Zo blijf je ontdekken.' : p.kort}</span>
          <span class="abo-koffie-voet">${voet}<span class="abo-vanaf">${pk ? '' : 'vanaf '}${geld(laagste(p))}</span></span>
        </span>
        <span class="abo-vink">${ico.vink}</span>
      </label>`;
    };
    const keus = (naam, waarde, binnen) => `<label class="abo-keus"><input class="rh-verborgen" type="radio" name="${naam}" value="${waarde}"><span class="abo-keus-binnen">${binnen}</span><span class="abo-vink">${ico.vink}</span></label>`;
    const teller = (soort, label, waarde) => `<div class="abo-teller" data-teller="${soort}">
      <button type="button" data-stap="-1" aria-label="${label} minder">${ico.min}</button>
      <output aria-live="polite">${waarde}</output>
      <button type="button" data-stap="1" aria-label="${label} meer">${ico.plus}</button></div>`;
    const kop = (nr, titel, soort) => `<legend><span class="abo-nr">${nr}</span><span class="abo-stap-titel smal">${titel}</span><span class="abo-gekozen" data-gekozen="${soort}"></span></legend>`;
    const MALING_UITLEG = { Gemalen: 'Direct te gebruiken, je hebt geen molen nodig.', Bonen: 'Voor een bonenmolen of volautomaat. Blijft het langst vers.' };

    raster.innerHTML = `
      <div class="abo-stappen">
        <fieldset class="abo-stap">${kop(1, 'Kies je koffie', 'koffie')}
          <div class="abo-koffies">${lijst.map(tegel).join('')}</div>
        </fieldset>
        <fieldset class="abo-stap">${kop(2, 'Hoeveel per levering', 'hoeveel')}
          <div class="abo-keuzes drie" data-gewichten>${GEWICHTEN.map((g, i) => keus('abo-gewicht', g,
            `${ico.zak(22 + i * 7)}<b>${g}</b><small>ca. ${kopjes(gram(g))} kopjes</small><em data-prijs></em>`)).join('')}</div>
          <div class="abo-vast" data-vast hidden>${ico.zak(36)}<span><b>6 zakken van 250 gram</b><small>Alle zes blends, ca. ${kopjes(1500)} kopjes</small></span></div>
          <div class="abo-rij"><span class="abo-rij-label">Aantal per levering</span>${teller('aantal', 'Eén', 1)}</div>
          <div class="abo-hulp">
            <div class="abo-hulp-vraag">${ico.kop}<span><b>Hoeveel kopjes drink je per dag?</b><small>Wij rekenen uit wat bij je past.</small></span></div>
            ${teller('kopjes', 'Eén kopje', 2)}
            <div class="abo-hulp-advies"><span data-advies aria-live="polite"></span><button type="button" class="abo-advies-knop" data-advies-knop>Neem over</button></div>
          </div>
        </fieldset>
        <fieldset class="abo-stap">${kop(3, 'Bonen of gemalen', 'maling')}
          <div class="abo-keuzes twee" data-malingen>${MALINGEN.map(m => keus('abo-maling', m,
            `${/bonen/i.test(m) ? ico.bonen : ico.gemalen}<b>${m}</b><small>${MALING_UITLEG[m] || ''}</small>`)).join('')}</div>
        </fieldset>
        <fieldset class="abo-stap">${kop(4, 'Hoe vaak', 'ritme')}
          <div class="abo-keuzes twee" data-ritmes>${RITMES.map(r => keus('abo-ritme', r,
            `${ico.kalender(r === 'twee' ? 14 : 30)}<b>${ritmeTekst(r)}</b><small>${r === 'twee' ? 26 : 12} leveringen per jaar</small><em data-maand></em>`)).join('')}</div>
          <p class="abo-verbruik" data-verbruik aria-live="polite"></p>
        </fieldset>
      </div>
      <aside class="abo-overzicht" aria-label="Jouw abonnement">
        <div class="abo-beeld"><i class="abo-gloed"></i><img data-abo-foto alt="" src="${(lijst.find(isPakket) || lijst[0]).foto}"></div>
        <div class="abo-samen">
          <div class="label">Jouw abonnement</div>
          <div class="abo-naam smal" data-abo-naam>Kies je koffie</div>
          <dl class="abo-lijst">
            <div><dt>Per levering</dt><dd data-r="hoeveel"></dd></div>
            <div><dt>Maling</dt><dd data-r="maling"></dd></div>
            <div><dt>Levering</dt><dd data-r="ritme"></dd></div>
          </dl>
          <div class="abo-prijs"><span data-abo-prijs></span><small data-abo-per>per levering</small></div>
          <p class="abo-maand" data-abo-maand></p>
        </div>
        <button type="button" class="knop abo-knop" data-abo-knop disabled><span class="lang" data-knop-lang>Kies eerst je koffie</span><span class="kort" data-knop-kort>Kies je koffie</span>${ico.pijl}</button>
        <p class="abo-noot">Vers gebrand en dezelfde dag verzonden.</p>
      </aside>`;

    const q = s => $(s, raster);
    const foto = q('[data-abo-foto]');
    const zet = (naam, waarde) => { const i = raster.querySelector(`input[name="${naam}"][value="${CSS.escape(waarde)}"]`); if (i) i.checked = true; };

    function advies() {
      const pk = st.p && isPakket(st.p);
      let beste = null;
      RITMES.forEach(ritme => {
        const nodig = st.kopjes * GRAM_PER_KOP * DAGEN[ritme];
        (pk ? ['pakket'] : GEWICHTEN).forEach(g => {
          for (let n = 1; n <= 4; n++) {
            const tot = gram(g) * n;
            let score = Math.abs(tot - nodig) / nodig + (n - 1) * .04;
            if (tot < nodig * .85) score += .3;                  // liever iets te veel dan te weinig
            if (ritme === 'maand' && tot > 1000) score += .15;   // veel koffie: liever vaker en dus verser
            if (!beste || score < beste.score) beste = { ritme, g, n, score };
          }
        });
      });
      return beste;
    }

    function werkBij() {
      const p = st.p, pk = p && isPakket(p);
      el.style.setProperty('--blend', p ? p.kleur : '#8a6a50');
      // hoeveelheid: prijzen per gewicht, uitverkochte keuzes uit
      q('[data-gewichten]').hidden = !!pk;
      q('[data-vast]').hidden = !pk;
      $$('input[name="abo-gewicht"]', raster).forEach(inp => {
        const em = inp.parentNode.querySelector('[data-prijs]');
        if (p) {
          const v = zoek(p, inp.value, st.maling);
          inp.disabled = !v || !v.beschikbaar;
          em.textContent = !v ? '' : v.beschikbaar ? geld(v.prijs) : 'Uitverkocht';
        } else {
          inp.disabled = false;
          const prijzen = blends.map(b => zoek(b, inp.value, st.maling)).filter(Boolean).map(v => v.prijs);
          em.textContent = prijzen.length ? 'vanaf ' + geld(Math.min(...prijzen)) : '';
        }
      });
      $$('input[name="abo-maling"]', raster).forEach(inp => {
        const v = p && zoek(p, st.gewicht, inp.value);
        inp.disabled = !!p && (!v || !v.beschikbaar);
      });
      const v = p ? zoek(p, st.gewicht, st.maling) : null;
      const perLevering = v ? v.prijs * st.aantal : 0;
      $$('input[name="abo-ritme"]', raster).forEach(inp => {
        inp.parentNode.querySelector('[data-maand]').textContent = v ? '≈ ' + geld(Math.round(perLevering * (inp.value === 'twee' ? 26 / 12 : 1))) + ' per maand' : '';
      });
      // tellers
      $('[data-teller="aantal"] output', raster).textContent = st.aantal;
      $('[data-teller="aantal"] [data-stap="-1"]', raster).disabled = st.aantal <= 1;
      $('[data-teller="aantal"] [data-stap="1"]', raster).disabled = st.aantal >= 6;
      $('[data-teller="kopjes"] output', raster).textContent = st.kopjes;
      $('[data-teller="kopjes"] [data-stap="-1"]', raster).disabled = st.kopjes <= 1;
      $('[data-teller="kopjes"] [data-stap="1"]', raster).disabled = st.kopjes >= 12;
      // advies op basis van kopjes per dag
      const a = advies();
      const adviesTekst = `${a.n > 1 ? a.n + ' × ' : ''}${a.g === 'pakket' ? 'proefpakket' : a.g}, ${ritmeTekst(a.ritme).toLowerCase()}`;
      q('[data-advies]').innerHTML = `Advies: <b>${adviesTekst}</b>`;
      const alGekozen = a.n === st.aantal && a.ritme === st.ritme && (a.g === 'pakket' || a.g === st.gewicht);
      const ak = q('[data-advies-knop]');
      ak.disabled = alGekozen; ak.textContent = alGekozen ? 'Gekozen' : 'Neem over';
      // samenvatting per stap
      const hoeveel = (st.aantal > 1 ? st.aantal + ' × ' : '') + (pk ? 'proefpakket' : st.gewicht);
      q('[data-gekozen="koffie"]').textContent = p ? (pk ? 'Proefpakket' : p.naam) : '';
      q('[data-gekozen="hoeveel"]').textContent = hoeveel;
      q('[data-gekozen="maling"]').textContent = st.maling;
      q('[data-gekozen="ritme"]').textContent = ritmeTekst(st.ritme);
      const totaal = gram(pk ? 'pakket' : st.gewicht) * st.aantal;
      q('[data-verbruik]').innerHTML = `${ico.kop}<span>Genoeg voor ongeveer <b>${kopjesTekst(totaal / GRAM_PER_KOP / DAGEN[st.ritme])} per dag</b> <small>(uitgaande van ${KOPJES_PER_250} kopjes per 250 gram)</small></span>`;
      // overzicht
      q('[data-abo-naam]').textContent = p ? (pk ? 'Proefpakket' : p.naam) : 'Kies je koffie';
      q('[data-r="hoeveel"]').textContent = pk ? hoeveel + ' (6 × 250 g)' : hoeveel;
      q('[data-r="maling"]').textContent = st.maling;
      q('[data-r="ritme"]').textContent = ritmeTekst(st.ritme);
      q('[data-abo-prijs]').textContent = p ? geld(perLevering) : 'vanaf ' + geld(Math.min(...blends.map(laagste)));
      q('[data-abo-per]').textContent = 'per levering';
      q('[data-abo-maand]').textContent = v ? (st.ritme === 'twee' ? '≈ ' + geld(Math.round(perLevering * 26 / 12)) + ' per maand, ' : '') + 'zelfde prijs als een losse bestelling' : '';
      const knop = q('[data-abo-knop]');
      const kan = !!(v && v.beschikbaar);
      knop.disabled = !kan;
      q('[data-knop-lang]').textContent = !p ? 'Kies eerst je koffie' : kan ? 'Abonnement toevoegen' : 'Niet leverbaar';
      q('[data-knop-kort]').textContent = !p ? 'Kies je koffie' : kan ? 'Toevoegen' : 'Niet leverbaar';
    }

    function kiesKoffie(handle) {
      const p = lijst.find(x => x.handle === handle); if (!p || p === st.p) return;
      st.p = p;
      // gekozen gewicht of maling niet leverbaar bij deze koffie: eerste die wel kan
      if (!isPakket(p)) {
        const v = zoek(p, st.gewicht, st.maling);
        if (!v || !v.beschikbaar) {
          const alt = voorkeursVariant(p.varianten);
          if (alt) { st.gewicht = alt.opties[p.opties.indexOf('Gewicht')]; st.maling = alt.opties[p.opties.indexOf('Maling')]; zet('abo-gewicht', st.gewicht); zet('abo-maling', st.maling); }
        }
      }
      q('.abo-overzicht').classList.add('gekozen');
      foto.classList.remove('in'); void foto.offsetWidth;
      foto.src = p.foto; foto.alt = 'Zak ' + p.naam;
      foto.classList.add('in');
      q('.abo-overzicht').classList.toggle('abo-met-pakket', isPakket(p));   // eigen naam: .pakket is al het proefpakketblok op de beginpagina
    }

    raster.addEventListener('change', e => {
      const t = e.target;
      if (t.name === 'abo-koffie') kiesKoffie(t.value);
      if (t.name === 'abo-gewicht') st.gewicht = t.value;
      if (t.name === 'abo-maling') st.maling = t.value;
      if (t.name === 'abo-ritme') st.ritme = t.value;
      werkBij();
    });
    raster.addEventListener('click', async e => {
      const stap = e.target.closest('[data-teller] [data-stap]');
      if (stap) {
        const soort = stap.closest('[data-teller]').dataset.teller, d = Number(stap.dataset.stap);
        if (soort === 'aantal') st.aantal = Math.min(6, Math.max(1, st.aantal + d));
        else st.kopjes = Math.min(12, Math.max(1, st.kopjes + d));
        werkBij(); return;
      }
      if (e.target.closest('[data-advies-knop]')) {
        const a = advies();
        if (a.g !== 'pakket') { st.gewicht = a.g; zet('abo-gewicht', a.g); }
        st.aantal = a.n; st.ritme = a.ritme; zet('abo-ritme', a.ritme);
        werkBij(); return;
      }
      const knop = e.target.closest('[data-abo-knop]');
      if (knop && st.p) {
        const v = zoek(st.p, st.gewicht, st.maling);
        const plan = st.p.plannen.find(pl => soortPlan(pl.naam) === st.ritme) || st.p.plannen[0];
        if (!v || !plan) return;
        knop.disabled = true;
        const tekst = q('[data-knop-lang]').textContent;
        q('[data-knop-lang]').textContent = 'Bezig met toevoegen';
        try { await voegToe([{ id: v.id, quantity: st.aantal, selling_plan: plan.id }]); }
        catch (err) { meld(err.message); }
        finally { q('[data-knop-lang]').textContent = tekst; werkBij(); }
      }
    });

    zet('abo-gewicht', st.gewicht); zet('abo-maling', st.maling); zet('abo-ritme', st.ritme);
    const vooraf = new URLSearchParams(location.search).get('koffie');   // bijv. ?koffie=simplissimo vanaf een productpagina
    if (vooraf && lijst.some(p => p.handle === vooraf)) { zet('abo-koffie', vooraf); kiesKoffie(vooraf); }
    werkBij();
  }
  $$('[data-abonneer]').forEach(abonneer);

  /* ---------- smaakkompas op de koffiepagina ---------- */
  // veld met twee assen (mild tot krachtig, fris en fruitig tot chocolade en noten); de klant sleept een bolletje naar zijn smaak,
  // de kaarten krijgen een match en schuiven op volgorde; het proefpakket blijft als vangnet achteraan
  function kompas(el) {
    const raster = $('[data-kompas-raster]');
    if (!raster) return;
    const kaarten = $$('.kaart', raster).filter(k => k.dataset.smaak && k.dataset.kracht);
    if (kaarten.length < 3) { el.remove(); return; }
    const rustig = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const beginVolgorde = $$('.kaart', raster);
    const punten = kaarten.map(k => ({
      k, handle: k.dataset.blend, naam: k.dataset.naam,
      kleur: k.style.getPropertyValue('--blend').trim() || '#8a6a50',
      x: .16 + (Number(k.dataset.kracht) - 1) / 4 * .68,   // mildste en krachtigste iets van de rand af
      foto: ($('.kaart-beeld img', k) || {}).src || '', url: ($('.kaart-beeld', k) || {}).href || '#',
      y: .9 - Number(k.dataset.smaak) / 100 * .8
    }));
    const SNEL = [['Fris en fruitig', .33, .8], ['Rond, voor elke dag', .5, .42], ['Avontuurlijk', .5, .64], ['Chocolade en noten', .67, .14], ['Krachtig met karakter', .84, .3]];
    el.innerHTML = `
      <div class="kompas-tekst">
        <div class="label">Smaakkompas</div>
        <h2 class="smal">${el.dataset.kop || 'Waar heb jij zin in?'}</h2>
        <p>${el.dataset.tekst || ''}</p>
        <div class="kompas-snel" role="group" aria-label="Snel kiezen">${SNEL.map(([t, x, y]) => `<button type="button" data-x="${x}" data-y="${y}">${t}</button>`).join('')}</div>
        <div class="kompas-top">
          <div class="kompas-top-kop"><span class="label">Jouw top 3</span><button type="button" class="kompas-naar" data-naar>Bekijk ze hieronder<svg class="rh-ico" aria-hidden="true"><use href="#i-pijl"/></svg></button></div>
          <ol class="kompas-top-lijst" aria-live="polite">${[1, 2, 3].map(n => `<li class="kt"><a class="kt-link" href="#" tabindex="-1"><span class="kt-beeld"><i class="kt-gloed"></i><img alt="" decoding="async"></span><span class="kt-nr">${n}</span><b class="smal kt-naam"></b><span class="kt-pct"></span></a></li>`).join('')}</ol>
          <p class="kompas-top-leeg">Sleep het bolletje of kies een smaak. Je top 3 verschijnt hier meteen.</p>
        </div>
        <div class="kompas-acties">
          <button type="button" class="kompas-herstel" data-herstel hidden>Vaste volgorde terug</button>
          ${el.dataset.pakket ? `<a class="kompas-pakket" href="${el.dataset.pakket}">Twijfel je? Proef ze allemaal<svg class="rh-ico" aria-hidden="true"><use href="#i-pijl"/></svg></a>` : ''}
        </div>
      </div>
      <div class="kompas-veld" data-veld>
        <span class="kompas-as boven">Chocolade &amp; noten</span><span class="kompas-as onder">Fris &amp; fruitig</span>
        <span class="kompas-as links">← Mild</span><span class="kompas-as rechts">Krachtig →</span>
        ${punten.map(p => `<button type="button" class="kompas-punt" style="--x:${p.x * 100}%;--y:${p.y * 100}%;--kleur:${p.kleur}" data-handle="${p.handle}"><i></i><span>${p.naam}</span></button>`).join('')}
        <div class="kompas-wijzer" tabindex="0" role="slider" aria-label="Jouw smaak. Sleep, of gebruik de pijltjestoetsen" aria-valuetext="Midden"><i></i><span class="kompas-hint" aria-hidden="true">Sleep mij</span></div>
      </div>`;
    const veld = $('[data-veld]', el), wijzer = $('.kompas-wijzer', el);
    wijzer.style.left = '70%'; wijzer.style.top = '72%';
    const knoppen = $$('.kompas-punt', el);
    // match-label op elke kaart
    kaarten.forEach(k => { const kop = $('.kaart-kop', k); if (kop && !$('.kaart-match', kop)) kop.insertAdjacentHTML('beforeend', '<span class="kaart-match" aria-hidden="true"></span>'); });
    // labels in het veld mogen elkaar niet raken: zo nodig een label onder het vorige schuiven
    function schikLabels() {
      const spans = knoppen.map(b => $('span', b));
      spans.forEach(s => { s.style.removeProperty('--schuif'); s.style.removeProperty('--schuif-x'); });
      const v = veld.getBoundingClientRect();
      const bezet = $$('.kompas-as', el).map(a => a.getBoundingClientRect());   // aslabels tellen als obstakel
      const raakt = (a, b) => a.left < b.right + 2 && a.right > b.left - 2 && a.top < b.bottom + 2 && a.bottom > b.top - 2;
      const binnen = b => b.left >= v.left + 4 && b.right <= v.right - 4 && b.top >= v.top + 4 && b.bottom <= v.bottom - 4;
      spans.map(s => ({ s, r: s.getBoundingClientRect(), d: s.previousElementSibling.getBoundingClientRect() })).sort((a, b) => a.r.top - b.r.top).forEach(({ s, r, d }) => {
        // plekken om te proberen: onder de stip (binnen de randen geschoven), boven, links, rechts; de eerste vrije wint
        const midY = (d.top + d.bottom) / 2 - r.height / 2 - r.top;
        const kandidaten = [[0, 0], [0, d.top - 4 - r.bottom], [d.left - 6 - r.right, midY], [d.right + 6 - r.left, midY]].map(([dx, dy]) => {
          let b = { left: r.left + dx, right: r.right + dx, top: r.top + dy, bottom: r.bottom + dy };
          const nx = b.left < v.left + 4 ? v.left + 4 - b.left : b.right > v.right - 4 ? v.right - 4 - b.right : 0;
          return { dx: dx + nx, dy, b: { ...b, left: b.left + nx, right: b.right + nx } };
        });
        const keus = kandidaten.find(k => binnen(k.b) && !bezet.some(x => raakt(k.b, x))) || kandidaten[0];
        if (keus.dx) s.style.setProperty('--schuif-x', keus.dx + 'px');
        if (keus.dy) s.style.setProperty('--schuif', keus.dy + 'px');
        bezet.push(keus.b);
      });
    }

    const START = { x: .7, y: .72 };   // leeg stuk rechtsonder: geen stip of naam onder het bolletje
    let pos = { ...START }, scores = new Map(), aan = false, sorteerTimer;
    const beschrijf = (x, y) => [x < .35 ? 'mild' : x > .65 ? 'krachtig' : 'gemiddeld sterk', y < .35 ? 'richting chocolade en noten' : y > .65 ? 'richting fris en fruitig' : 'rond en gebalanceerd'].join(', ');
    function zet(x, y, opties = {}) {
      pos = { x: Math.min(.97, Math.max(.03, x)), y: Math.min(.97, Math.max(.03, y)) };
      wijzer.classList.toggle('glijd', !!opties.glijd);
      wijzer.style.left = pos.x * 100 + '%'; wijzer.style.top = pos.y * 100 + '%';
      wijzer.setAttribute('aria-valuetext', beschrijf(pos.x, pos.y));
      if (!aan) { aan = true; el.classList.add('aan'); raster.classList.add('kompas-aan'); $('[data-herstel]', el).hidden = false; }
      punten.forEach(p => {
        const s = Math.max(0, 1 - Math.hypot(p.x - pos.x, p.y - pos.y) / .7);
        scores.set(p.k, s);
        const knop = knoppen.find(b => b.dataset.handle === p.handle);
        knop.style.setProperty('--s', s.toFixed(3));
        p.k.style.setProperty('--s', s.toFixed(3));
        const m = $('.kaart-match', p.k); if (m) m.textContent = Math.round(s * 100) + '% match';
      });
      const volgorde = [...punten].sort((a, b) => scores.get(b.k) - scores.get(a.k));
      const beste = volgorde[0];
      punten.forEach(p => { const plek = volgorde.indexOf(p); p.k.classList.toggle('top', plek < 3); });   // top 3 uitlichten
      el.style.setProperty('--beste', beste.kleur);
      // top 3 in het kompas zelf: direct zichtbaar wat de keuze doet, zonder te scrollen
      $$('.kt', el).forEach((li, i) => {
        const p = volgorde[i], a = $('.kt-link', li);
        if (li.dataset.handle !== p.handle) {
          li.dataset.handle = p.handle;
          li.style.setProperty('--kleur', p.kleur);
          const img = $('img', li); img.src = p.foto; img.alt = 'Zak ' + p.naam;
          $('.kt-naam', li).textContent = p.naam;
          a.href = p.url; a.removeAttribute('tabindex'); a.setAttribute('aria-label', 'Nummer ' + (i + 1) + ': ' + p.naam);
          li.classList.remove('wissel'); void li.offsetWidth; li.classList.add('wissel');
        }
        $('.kt-pct', li).textContent = Math.round(scores.get(p.k) * 100) + '% match';
      });
      punten.forEach(p => p.k.classList.toggle('beste', p === beste));
      if (opties.sorteer) { clearTimeout(sorteerTimer); sorteerTimer = setTimeout(sorteer, opties.direct ? 0 : 350); }
    }
    // kaarten op volgorde zetten met een vloeiende overgang (eerst meten, dan verplaatsen, dan terug laten glijden)
    function zetVolgorde(nieuw) {
      const voor = new Map(nieuw.map(k => [k, k.getBoundingClientRect()]));
      raster.append(...nieuw);
      nieuw.forEach((k, i) => {
        const nr = $('.nr', k); if (nr) nr.textContent = String(i + 1).padStart(2, '0') + ' / ' + String(nieuw.length).padStart(2, '0');
        if (rustig) return;
        const a = voor.get(k), b = k.getBoundingClientRect();
        const dx = a.left - b.left, dy = a.top - b.top;
        if (dx || dy) k.animate([{ transform: `translate(${dx}px, ${dy}px)` }, { transform: 'none' }], { duration: 650, easing: 'cubic-bezier(.2,.75,.2,1)' });
      });
    }
    function sorteer() {
      const blends = [...kaarten].sort((a, b) => scores.get(b) - scores.get(a));
      // telefoon: de kaarten staan in een schuifrij die op kaarten vastklikt; dat vastklikken even uit, anders blijft de browser
      // de kaart volgen die eerst vooraan stond; daarna terug naar nummer één zodat de beste match vooraan te zien is
      const schuifrij = raster.scrollWidth > raster.clientWidth + 2;
      if (schuifrij) raster.style.scrollSnapType = 'none';
      zetVolgorde([...blends, ...beginVolgorde.filter(k => !kaarten.includes(k))]);
      if (schuifrij) {
        raster.scrollLeft = 0;
        setTimeout(() => { raster.scrollLeft = 0; raster.style.removeProperty('scroll-snap-type'); }, 150);
      }
    }
    function herstel() {
      aan = false; el.classList.remove('aan'); raster.classList.remove('kompas-aan'); $('[data-herstel]', el).hidden = true;
      kaarten.forEach(k => k.classList.remove('beste', 'top'));
      $$('.kt', el).forEach(li => { delete li.dataset.handle; $('.kt-link', li).setAttribute('tabindex', '-1'); });
      wijzer.classList.add('glijd'); wijzer.style.left = START.x * 100 + '%'; wijzer.style.top = START.y * 100 + '%'; pos = { ...START };
      zetVolgorde(beginVolgorde);
    }

    // klikken of tikken in het veld: bolletje daarheen; op een stip: precies op die blend
    veld.addEventListener('click', e => {
      if (e.target.closest('.kompas-wijzer') || sleept) return;
      const punt = e.target.closest('.kompas-punt');
      if (punt) { const p = punten.find(x => x.handle === punt.dataset.handle); zet(p.x, p.y, { glijd: true, sorteer: true }); return; }
      const r = veld.getBoundingClientRect();
      zet((e.clientX - r.left) / r.width, (e.clientY - r.top) / r.height, { glijd: true, sorteer: true });
    });
    // slepen met muis of vinger
    let sleept = false;
    wijzer.addEventListener('pointerdown', e => { e.preventDefault(); wijzer.setPointerCapture(e.pointerId); sleept = true; wijzer.classList.add('sleept'); });
    wijzer.addEventListener('pointermove', e => {
      if (!sleept) return;
      const r = veld.getBoundingClientRect();
      zet((e.clientX - r.left) / r.width, (e.clientY - r.top) / r.height);
    });
    const los = () => { if (!sleept) return; wijzer.classList.remove('sleept'); setTimeout(() => { sleept = false; }, 0); zet(pos.x, pos.y, { sorteer: true, direct: true }); };
    wijzer.addEventListener('pointerup', los);
    wijzer.addEventListener('pointercancel', los);
    wijzer.addEventListener('keydown', e => {
      const stap = e.shiftKey ? .12 : .05;
      const d = { ArrowLeft: [-stap, 0], ArrowRight: [stap, 0], ArrowUp: [0, -stap], ArrowDown: [0, stap] }[e.key];
      if (!d) return;
      e.preventDefault();
      zet(pos.x + d[0], pos.y + d[1], { sorteer: true });
    });
    $('.kompas-snel', el).addEventListener('click', e => {
      const b = e.target.closest('button'); if (!b) return;
      zet(Number(b.dataset.x), Number(b.dataset.y), { glijd: true, sorteer: true });
    });
    $('[data-herstel]', el).addEventListener('click', herstel);
    $('[data-naar]', el).addEventListener('click', () => raster.scrollIntoView({ behavior: rustig || document.hidden ? 'instant' : 'smooth', block: 'start' }));
    requestAnimationFrame(schikLabels);
    addEventListener('resize', schikLabels);
    if (document.fonts) document.fonts.ready.then(schikLabels);
  }
  $$('[data-kompas]').forEach(kompas);

  /* ---------- held met blendkiezer ---------- */
  const held = $('[data-held]');
  if (held) {
    const producten = JSON.parse($('[data-blends]', held).textContent || '[]');
    const introEl = $('[data-intro-json]', held);
    const intro = introEl ? JSON.parse(introEl.textContent) : null;
    if (intro && intro.toon && producten.length) {
      // laagste prijs van alle blends voor 'Vanaf' op de eerste slide
      const centen = producten.map(p => p.prijs_c).filter(n => typeof n === 'number');
      if (!intro.prijs) intro.prijs = centen.length ? geld(Math.min(...centen)) : producten[0].prijs;
      intro.beschikbaar = true;
      producten.unshift(intro);
    }
    if (producten.length) start(held, producten);
  }

  function start(held, producten) {
    const h = k => held.querySelector('[data-h="' + k + '"]');
    const kiezer = $('[data-kiezer]', held);
    const balk = $('[data-kiezer-balk]', held);
    const wijzer = $('[data-wijzer]', held);
    const podium = $('.podium', held);
    const info = $('.podium-info', held);
    const zak = $('[data-zakken]', held);
    const N = producten.length;
    const rustig = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const tw = n => String(n).padStart(2, '0');
    kiezer.innerHTML = producten.map((p, i) => `<button type="button" role="tab" aria-label="${p.naam}" style="--kleur:${p.kleur};--n:${i}" aria-selected="false" tabindex="-1"><span class="stip${p.type === 'intro' ? ' alle' : ''}"></span><span class="kn-naam">${p.naam}</span></button>`).join('');
    // gloed achter elke zak in de kleur van het etiket; plekken als deel van de foto (zelfde opname voor alle blends)
    const kleurVan = handle => (producten.find(q => q.handle === handle) || {}).kleur;
    const plekken = p => p.type === 'intro'
      ? PAKKET.map(z => ({ ...z, kleur: kleurVan(z.handle) })).filter(z => z.kleur)
      : [{ ...ZAK_LOS, kleur: p.kleur }];
    const gloedHtml = (p, i) => `<div class="gloed-laag${p.type === 'intro' ? '' : ' los'}" aria-hidden="true" data-i="${i}">${plekken(p).map(z =>
      `<i class="gloed" style="--kleur:${z.kleur};--x:${z.x * 100}%;--y:${(z.boven + z.onder) * 50}%;--b:${z.b * 100}%;--h:${(z.onder - z.boven) * 100}%"></i>`).join('')}</div>`;
    zak.innerHTML = producten.map((p, i) => gloedHtml(p, i) + `<img class="zak-beeld${p.type === 'intro' ? ' breed' : ''}" src="${p.foto}" alt="" aria-hidden="true" data-i="${i}">`).join('');
    const blendNr = producten.map((p, i) => producten.slice(0, i + 1).filter(x => x.type !== 'intro').length);
    const NB = producten.filter(x => x.type !== 'intro').length;
    const knoppen = [...kiezer.children];
    // binnenkomst van de balk: tabs verschijnen een voor een, daarna loopt er een lichtgolf over alle koffies
    // en geeft de pijl naar rechts twee duwtjes; zo is meteen te zien dat er meer te kiezen is
    const baan = $('.baan', balk);
    baan.style.setProperty('--N', N);
    if (!rustig && 'IntersectionObserver' in window) {
      baan.classList.add('wacht');
      const io = new IntersectionObserver(([e]) => {
        if (!e.isIntersecting) return;
        io.disconnect();
        baan.classList.replace('wacht', 'rondgang');
        setTimeout(() => baan.classList.remove('rondgang'), 700 + N * 110 + 1100);
      }, { threshold: .6 });
      io.observe(baan);
      setTimeout(() => { if (baan.classList.contains('wacht')) { io.disconnect(); baan.classList.remove('wacht'); } }, 8000);   // vangnet: balk nooit onzichtbaar laten
    }
    const zakken = [...zak.querySelectorAll('.zak-beeld')];
    const gloeden = [...zak.querySelectorAll('.gloed-laag')];
    // de gloedlaag krijgt precies de maat van het zichtbare deel van de foto (object-fit: contain, onderaan uitgelijnd)
    function plaatsGloed() {
      zakken.forEach((img, j) => {
        const g = gloeden[j]; if (!img.naturalWidth || !img.offsetWidth) return;
        const w = img.offsetWidth, hh = img.offsetHeight;
        const s = Math.min(w / img.naturalWidth, hh / img.naturalHeight);
        const cw = img.naturalWidth * s, ch = img.naturalHeight * s;
        g.style.left = (img.offsetLeft - w / 2 + (w - cw) / 2) + 'px';
        g.style.top = (img.offsetTop + hh - ch) + 'px';
        g.style.width = cw + 'px'; g.style.height = ch + 'px';
      });
    }
    zakken.forEach(img => img.complete ? null : img.addEventListener('load', plaatsGloed, { once: true }));
    const tekstDelen = ['reus', 'naam', 'kort', 'tags'].map(h);
    let actief = -1;

    function pasReus() {
      const el = h('reus'); el.style.fontSize = '';
      const ruimte = el.clientWidth, nodig = el.scrollWidth;
      if (nodig > ruimte) el.style.fontSize = (parseFloat(getComputedStyle(el).fontSize) * ruimte / nodig * .98) + 'px';
    }
    // wijzer: bij een wissel eerst uitrekken over de oude en de nieuwe tab, dan samentrekken op de nieuwe (vloeiend, als een druppel)
    let rekTimer;
    // op een telefoon staat de balk rechtop naast de zak; dan beweegt de wijzer van boven naar beneden
    const staand = () => getComputedStyle(baan).flexDirection === 'column';
    function zetWijzer(vanaf) {
      const b = knoppen[actief]; if (!b) return;
      const v = staand(), plek = el => v ? el.offsetTop : el.offsetLeft, maat = el => v ? el.offsetHeight : el.offsetWidth;
      kiezer.setAttribute('aria-orientation', v ? 'vertical' : 'horizontal');
      const zet = (p, m) => {
        wijzer.style.width = v ? '' : m + 'px'; wijzer.style.height = v ? m + 'px' : '';
        wijzer.style.transform = (v ? 'translateY(' : 'translateX(') + p + 'px)';
      };
      const naar = () => { wijzer.classList.remove('rekt'); zet(plek(b), maat(b)); };
      clearTimeout(rekTimer);
      const oud = knoppen[vanaf];
      if (oud && oud !== b && !rustig && wijzer.style.transform) {
        const a0 = Math.min(plek(oud), plek(b)), a1 = Math.max(plek(oud) + maat(oud), plek(b) + maat(b));
        wijzer.classList.add('rekt');
        zet(a0, a1 - a0);
        rekTimer = setTimeout(naar, 170);
      } else naar();
    }
    addEventListener('resize', () => {
      indeling(); pasReus(); plaatsGloed(); held.style.setProperty('--wijzer-t', '0s'); zetWijzer();
      void wijzer.offsetWidth;   // nieuwe plek eerst vastleggen, anders glijdt de wijzer alsnog (bijvoorbeeld van liggend naar staand)
      requestAnimationFrame(() => held.style.removeProperty('--wijzer-t'));
    });
    indeling();
    if (document.fonts) document.fonts.ready.then(() => { indeling(); pasReus(); zetWijzer(); plaatsGloed(); });

    // tekst links van de foto; ook gebruikt om vooraf de hoogste slide te meten
    function vulTekst(q, p, i) {
      const isIntro = p.type === 'intro';
      q('teller').textContent = isIntro ? (p.teller || '') : 'Blend ' + tw(blendNr[i]) + ' van ' + tw(NB);
      q('naam').textContent = p.titel || p.naam;
      q('naam').classList.toggle('lang', (p.titel || p.naam).length > 28);   // lange kop iets kleiner
      q('kort').textContent = p.kort;
      q('tags').innerHTML = (p.profiel || []).filter(Boolean).map(t => `<span class="tag">${t}</span>`).join('');
      q('open-tekst').textContent = p.knop1 || 'Bekijk blend';
      q('snel-tekst').textContent = isIntro ? (p.knop2 || 'Bekijk alle koffie') : 'Winkelwagen';
      q('snel').hidden = !isIntro && !p.beschikbaar;
    }

    // Indeling op brede schermen: de held is precies schermhoog, zodat de blendbalk op elke slide op dezelfde plek staat.
    // De hoogste tekst van alle slides moet onder de grote achtergrondnaam passen; is er te weinig ruimte,
    // dan wordt die naam kleiner (de tekst zelf nooit). Pas bij een heel laag scherm wordt de held hoger, voor alle slides even veel.
    function indeling() {
      info.style.minHeight = '';
      const titel = $('.podium-titel', info);
      if (titel) titel.style.minHeight = '';
      const smal = innerWidth <= 900;
      if (smal) held.style.removeProperty('--reus');
      // hoogste tekst van alle slides meten in een onzichtbare kopie met dezelfde breedte
      const kloon = info.cloneNode(true);
      kloon.querySelectorAll('.tekst-in').forEach(el => el.classList.remove('tekst-in'));
      Object.assign(kloon.style, { position: 'absolute', visibility: 'hidden', pointerEvents: 'none', left: '0', top: '0', width: info.offsetWidth + 'px', minHeight: '0', paddingTop: '0', paddingBottom: '0' });
      const q = k => kloon.querySelector('[data-h="' + k + '"]');
      info.parentNode.appendChild(kloon);
      // smal scherm: de knoppen staan direct onder de kop; het kopblok krijgt de hoogte van de langste kop,
      // zodat de knoppen bij elke slide op dezelfde plek blijven staan
      const kloonTitel = $('.podium-titel', kloon);
      if (smal && titel && kloonTitel) {
        let titelH = 0;
        producten.forEach((p, i) => { vulTekst(q, p, i); titelH = Math.max(titelH, kloonTitel.offsetHeight); });
        titel.style.minHeight = kloonTitel.style.minHeight = titelH + 'px';
      }
      let tekstH = 0;
      producten.forEach((p, i) => { vulTekst(q, p, i); tekstH = Math.max(tekstH, kloon.offsetHeight); });
      kloon.remove();
      const pi = getComputedStyle(info), onderInfo = parseFloat(pi.paddingBottom);
      // smal scherm: alle slides even hoog, knoppen op een vaste plek, zodat de pagina eronder niet verspringt
      if (smal) { info.style.minHeight = (parseFloat(pi.paddingTop) + tekstH + onderInfo) + 'px'; return; }
      const vh = innerHeight / 100;
      const kop = parseFloat(getComputedStyle(held).paddingTop), onder = parseFloat(getComputedStyle(podium).paddingBottom) + onderInfo;
      const hoog = Math.max(760, innerHeight);
      const lucht = 2 * vh + 28;   // zelfde als padding-top van .podium-info in theme.css
      const opBreedte = Math.min(300, Math.max(96, document.documentElement.clientWidth * .17));
      const past = (hoog - kop - balk.offsetHeight - onder - lucht - tekstH) / .85;
      const reus = Math.max(opBreedte * .6, Math.min(opBreedte, past));   // nooit kleiner dan 60%; daaronder wordt de held hoger
      held.style.setProperty('--reus', reus + 'px');
      info.style.minHeight = (lucht + reus * .85 + tekstH + onderInfo) + 'px';
    }

    function toon(i, opties = {}) {
      const p = producten[i]; const vorige = actief; actief = i;
      if (opties.richting) {
        held.style.setProperty('--in-x', (70 * opties.richting) + 'px');
        held.style.setProperty('--uit-x', (-70 * opties.richting) + 'px');
      }
      knoppen.forEach((b, j) => { b.setAttribute('aria-selected', j === i); b.tabIndex = j === i ? 0 : -1; });
      held.style.setProperty('--blend', p.kleur);
      h('reus').textContent = p.reus || p.naam; pasReus();
      vulTekst(h, p, i);
      // hoofdknop: op de eerste slide het proefpakket kiezen, bij een blend naar de productpagina
      const open = h('open');
      open.href = p.url;
      if (p.kies1) open.dataset.kies = p.kies1; else open.removeAttribute('data-kies');
      // tweede knop: op de eerste slide naar alle koffie, bij een blend gewicht en maling kiezen
      const snel = h('snel');
      const isIntro = p.type === 'intro';
      snel.href = isIntro ? p.url2 : p.url;
      if (isIntro) snel.removeAttribute('data-kies'); else snel.dataset.kies = p.handle;
      snel.classList.toggle('pijl-achter', isIntro);
      h('snel-ico').setAttribute('href', isIntro ? '#i-pijl' : '#i-plus');
      zak.classList.toggle('met-intro', p.type === 'intro');
      // rijen naast de foto: bij het proefpakket prijs, inhoud, maling en smaken, bij een blend de koffiegegevens
      const pakket = p.type === 'intro';
      const rij = (dt, label, el, waarde) => { h(dt).textContent = label; el.textContent = waarde || ''; el.closest('.spec').hidden = !waarde; };
      h('dt1').textContent = pakket ? 'Prijs' : 'Vanaf';
      h('prijs').textContent = p.prijs;
      h('meter').innerHTML = pakket ? '' : [1, 2, 3, 4, 5].map(k => `<i class="${k <= p.kracht ? 'aan' : ''}"></i>`).join('');
      h('meter').hidden = pakket;
      h('meter').setAttribute('aria-label', 'Intensiteit ' + p.kracht + ' van 5');
      h('dt2').textContent = pakket ? 'Inhoud' : 'Intensiteit';
      h('dd2').textContent = pakket ? (p.inhoud || '') : '';
      h('meter').closest('.spec').hidden = pakket ? !p.inhoud : !p.kracht;
      rij('dt3', pakket ? 'Maling' : 'Herkomst', h('herkomst'), pakket ? p.maling : p.herkomst);
      rij('dt4', pakket ? 'Smaken' : 'Perfect voor', h('voor'), pakket ? p.smaken : p.voor);
      zakken.forEach((z, j) => {
        z.classList.toggle('aan', j === i);
        z.classList.toggle('weg', j === vorige && j !== i);
        z.alt = j === i ? 'Zak ' + p.naam + ' koffie' : '';
        z.toggleAttribute('aria-hidden', j !== i);
        gloeden[j].classList.toggle('aan', j === i);
        gloeden[j].classList.toggle('weg', j === vorige && j !== i);
      });
      plaatsGloed();
      zetWijzer(vorige);
      if (opties.tekst) tekstDelen.forEach(el => { el.classList.remove('tekst-in'); void el.offsetWidth; el.classList.add('tekst-in'); });
    }

    const intro = held.dataset.intro || 'slider';
    const klaar = Promise.race([
      Promise.all(zakken.map(z => z.decode ? z.decode().catch(() => {}) : Promise.resolve())),
      new Promise(r => setTimeout(r, 2500))
    ]);
    let handmatig = j => toon(j, { tekst: true });

    if (intro === 'slider' && N > 1) {
      const sec = Number(held.dataset.interval) || 5;
      held.style.setProperty('--interval', sec + 's');
      held.style.setProperty('--zak-t', '.8s');
      held.style.setProperty('--in-y', '0px'); held.style.setProperty('--uit-y', '0px');
      held.style.setProperty('--in-x', '70px'); held.style.setProperty('--uit-x', '-70px');
      const knop = document.createElement('button');
      knop.type = 'button'; knop.className = 'speelknop';
      $('.baan', balk).appendChild(knop);
      let speelt = !rustig;
      const zetKnop = () => {
        knop.innerHTML = '<svg class="rh-ico"><use href="#i-' + (speelt ? 'pauze' : 'speel') + '"/></svg>';
        knop.setAttribute('aria-label', speelt ? 'Automatisch wisselen pauzeren' : 'Automatisch wisselen starten');
      };
      const herstart = () => {
        wijzer.classList.remove('loopt'); knoppen.forEach(b => b.classList.remove('straks'));
        void wijzer.offsetWidth;
        if (speelt) { wijzer.classList.add('loopt'); knoppen[(actief + 1) % N].classList.add('straks'); }   // volgende koffie kondigt zich aan
      };
      wijzer.querySelector('i').addEventListener('animationend', () => { if (speelt) { toon((actief + 1) % N, { tekst: true, richting: 1 }); herstart(); } });
      const redenen = new Set();
      const pauze = (r, aan) => { aan ? redenen.add(r) : redenen.delete(r); wijzer.classList.toggle('pauze', redenen.size > 0); baan.classList.toggle('pauze', redenen.size > 0); };
      // alleen pauzeren als de muis (of het toetsenbord) in de balk met de blends zelf is, niet ernaast
      baan.addEventListener('mouseenter', () => pauze('muis', true));
      baan.addEventListener('mouseleave', () => pauze('muis', false));
      baan.addEventListener('focusin', e => pauze('focus', e.target.matches(':focus-visible')));   // alleen toetsenbordfocus, een muisklik pauzeert niet
      baan.addEventListener('focusout', () => pauze('focus', false));
      document.addEventListener('visibilitychange', () => pauze('verborgen', document.hidden));
      new IntersectionObserver(([e]) => pauze('uitbeeld', !e.isIntersecting), { threshold: .35 }).observe(held);
      new MutationObserver(() => pauze('venster', document.documentElement.classList.contains('rh-vast'))).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      knop.addEventListener('click', () => { speelt = !speelt; zetKnop(); herstart(); });
      // zelf een blend kiezen: die blend tonen en de timer daar opnieuw laten beginnen; zolang de muis op de balk staat pauzeert hij, daarna loopt hij door
      handmatig = j => { toon(j, { tekst: true, richting: j > actief ? 1 : -1 }); herstart(); };
      zetKnop(); toon(0); klaar.then(herstart);
    } else {
      toon(0);
    }

    knoppen.forEach((b, j) => b.addEventListener('click', () => handmatig(j)));
    const vorige = $('[data-vorige]', held), volgende = $('[data-volgende]', held);
    if (vorige) vorige.addEventListener('click', () => handmatig((actief - 1 + N) % N));
    if (volgende) volgende.addEventListener('click', () => handmatig((actief + 1) % N));
    kiezer.addEventListener('keydown', e => {
      const d = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
      if (!d) return;
      e.preventDefault();
      const n = (actief + d + N) % N;
      handmatig(n); knoppen[n].focus();
    });
  }
})();
